/**
 * 策略预估每日收益（列表卡 / 详情 / 加仓共用）
 */

export function getAvgDailyReturnRateFromStrategyDetail(detail) {
  if (!detail || typeof detail !== "object") return null;
  const raw = detail.avgDailyReturnRate ?? detail.avg_daily_return_rate ?? detail.averageDailyReturnRate;
  if (raw == null || String(raw).trim() === "") return null;
  const n = parseFloat(String(raw).replace(/,/g, ""));
  if (!Number.isFinite(n)) return null;
  return n / 100;
}

export function formatEstimatedDailyAmountForDisplay(n) {
  if (!Number.isFinite(n) || n < 0) return null;
  const s = n.toFixed(6).replace(/\.?0+$/, "");
  return s || "0";
}

export function buildAicopyEstimatedDailyProfitText({
  amountNum,
  avgDailyReturnRate,
  formatNumber,
  currency = "USDT",
  t,
}) {
  if (!Number.isFinite(amountNum) || amountNum <= 0 || avgDailyReturnRate == null) return null;
  const estimated = amountNum * avgDailyReturnRate;
  const estAmtStr = formatEstimatedDailyAmountForDisplay(estimated);
  if (estAmtStr == null) return null;
  return t("aicopy.estimatedDailyProfitUsdt", {
    amount: formatNumber(estAmtStr),
    currency,
  });
}
